import React, {PureComponent, ReactNode} from "react";
import {Garage} from "@App/types";
import {Text} from "@eo-locale/react";


export type GarageProfileHeadlineProps = {
    garage: Garage
};

export class GarageProfileHeadline extends PureComponent<GarageProfileHeadlineProps> {

    render(): ReactNode {
        const {
            garage
        } = this.props

        return (
            <div className={'garageProfile__headline col-span-12 grid order-1 lg:order-none grid-cols-12 mb-5'}>
                <div className="col-span-12 md:col-span-8">
                    <h1 className={'text-2xl leading-8 lg:text-4xl lg:leading-10 font-medium font-serif text-gray-900 flex-grow mb-3'}>{garage.name}</h1>

                    <div className={'grid grid-cols-8 lg:flex-row gap-1 flex-wrap text-sm mb-3 justify-start md:flex md:flex-wrap'}>
                        <div className={'col-span-full md:col-span-2 order-1'}>
                            <i className={`fa-kit fa-star fa-fw text-yellow-500 text-regular relative inline-block`}/> <strong>{(garage.rating / 100 * 5).toFixed(2)}</strong> · <a href={'#reviews'} className={'font-light text-gray-900'}>{garage.review_count} <Text id={'ratings'}/></a>
                        </div>
                        <div className={'col-span-full md:col-span-6 order-3 md:order-2 md:ml-3'}>
                            <a href="#garage-location" className={'font-light text-gray-900'}>{garage.street} - {garage.postcode} {garage.city} {garage.baseDistrict?.name}</a>
                        </div>

                        <div className={'col-span-full order-2 md:order-3 flex items-center gap-3 md:basis-full'}>
                            {garage.garageConcept && (
                                <div className={'flex items-center gap-x-2'}>
                                    <img loading={'lazy'}
                                         className={'h-6'}
                                         src={process.env.NEXT_PUBLIC_IMG_SRC + garage.garageConcept.logo}
                                         alt={garage.garageConcept.name}
                                    />{garage.garageConcept.name}
                                </div>
                            )}
                            {garage.checkpoint?.id && (
                                <div>
                                    <span className={'flex items-center gap-2'}>
                                        <img width={'75'}
                                             src={process.env.NEXT_PUBLIC_IMG_SRC && process.env.NEXT_PUBLIC_IMG_SRC + garage.checkpoint?.logo}
                                             alt={garage.checkpoint?.name}
                                        /> Prüfort
                                    </span>
                                    {/*TODO: Add official brands*/}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="col-span-4 items-center justify-end hidden md:flex md:visible">
                    <a href="#booking" className={'relative bg-primary-500 px-12 py-2 mt-5 text-white rounded-lg font-normal text-center no-underline'}><Text id={'book_appointment'}/></a>
                </div>
            </div>
        )
    }
}
